module.exports = __webpack_public_path__ + "static/media/GAOFEN 1.64907638.czml";